<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar :ajaxSearch="false" v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
                                placeholder="请输入姓名、手机号、邮箱进行搜索"></search-bar>
                </div>
            </div>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-button icon="el-icon-plus" type="primary" @click="addRecord()">添加帐号</el-button>
                        <el-button icon="el-icon-my-daochu" type="info" @click="exportFiles(idStr, '/bole', '/exportBole.api')">导出帐号</el-button>
                        <file-upload
                                upload-mode="silence"
                                class="ml-5 mr-5"
                                style="display: inline-block;"
                                :action="`${$axios.defaults.baseURL}/bole/importBole.api`"
                                accept=".xls"
                                :on-success="uploadSuccess"
                                :fileLimit="0"
                                :showLoading="true">
                            <el-button :plain="true" icon="el-icon-upload2" type="primary">导入帐号</el-button>
                            <span slot="tip"></span>
                        </file-upload>
                        <a :href="downloadTemplateUrl">
                            <el-button icon="el-icon-my-daochu" :plain="true" type="text">下载导入模版</el-button>
                        </a>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.mobilephone }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="一级部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.firDeptName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="二级部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.secDeptName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="三级部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.thrDeptName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="外包工号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.jobNumber }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="外包公司邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ scope.row.email }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="60">
                            <template slot-scope="scope">
                                <el-button type="text" @click="addRecord(scope.row)">编辑</el-button>
                                <el-button type="text" @click="removeRecord(scope.row)"><span
                                        class="color-danger">删除</span></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mb-20 mt-10"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <add-bole-dialog ref="addBoleDialog" @reload="fetchData"></add-bole-dialog>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import FileUpload from 'components/fileUpload'
    import operationMixin from 'views/operation/operationMixin'
    import AddBoleDialog from './addBoleDialog'

    export default {
        'extends': QueryListExtend,
        components: {FileUpload, AddBoleDialog},
        mixins: [operationMixin],
        data () {
            return {
                fetchUrl: '/bole/list.api',
                urls: {
                    remove: '/bole/deleteById.api'
                },
                searchData: {
                    searchWord: null
                }
            }
        },
        computed: {
            downloadTemplateUrl () {
                return `${this.$axios.defaults.baseURL}/bole/downloadTemplate.api?token=${this.$store.state.app.token}`
            }
        },
        methods: {
            addRecord (data) {
                this.$refs.addBoleDialog.show(data)
            },
            removeRecord (data) {
                this.$confirm(`是否删除【${data.name}】这条记录？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post(this.urls.remove, {id: data.id}, {'X-showMessage': true}).then(res => {
                        this.fetchData()
                    })
                })
            },
            uploadSuccess (res, file) {
                this.fetchData()
                const h = this.$createElement
                let nodeContent = res.result.list.map(item => {
                    return h('p', null, item)
                })
                this.$notify({
                    title: '导入结果提示：',
                    duration: 0,
                    message: h('div', {
                        style: {
                            maxHeight: '500px',
                            overflow: 'auto'
                        }
                    }, nodeContent),
                    type: res.result.isAllSuccess ? 'success' : 'error'
                })
            }
        }
    }
</script>
<style type="text/scss">
</style>


// WEBPACK FOOTER //
// boleList.vue?9c15bf12